$(document).ready(function(){



$('.slider_testimonial').slick({
  dots: true,
  infinite: true,
  speed: 300,
  arrows: false,
  slidesToShow: 1,
  adaptiveHeight: true
});

// --- ( Product Accordion ) ---
const accordionBtns = document.querySelectorAll(".accordion");
accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});

   $(document).find('#cstm_variants').change(function() {
  var option = $(this).find('option:selected');
  window.location.href = option.data("url");
});

  $(document).on('click', 'button.quantity__button', function(){
    var qtyVal = Number($(this).siblings('.quantity__input').val());
    var getPrice = Number($('.price__regular').attr('data-price'));
    var updatePrice = getPrice*qtyVal / 100;
    console.log(updatePrice);
    $('.product__price .customprice').text('$'+updatePrice+'USD');
    $('.add-cart-btn .CustomPrice').text('$'+updatePrice+'USD');
  });


  // --- ( Faq Popup Start ) ---
  $(document).on('click', '.Itg--page-faq .account_popup p a', function(){
    var popup_ = $(document).find('.cstm_overlays').css("display", "block");
    var popup_ = $(document).find('#myModal').css("display", "block");
  });
   $(document).on('click', '.Itg--page-faq .popup_top span.close', function(){
    var popup_ = $(document).find('.cstm_overlays').css("display", "none");
    var popup_ = $(document).find('#myModal').css("display", "none");
  });
  
  // --- ( Faq Popup End ) ---


  // --- ( Trio Product bundle select only 3 Start ) ---
  
  $(document).on('click', '.template--bundle-sweet-trio .rbr-hr_products .rbr-hrProducts__container', function(){
    $('.template--bundle-sweet-trio .rbr-hr_products .rbr-hrProducts__container').each(function(){
      var lengthSelected = ($('.selected').length);
      console.log(lengthSelected)
      if(lengthSelected == 3){
        $(".rbr-hrProducts__container:not('.selected') .rbr-checkbox__container input").attr('disabled', 'disabled');
      }else{
        $(".rbr-hrProducts__container:not('.selected') .rbr-checkbox__container input").removeAttr('disabled');
      }
    });
  });


  $(document).on('click', '.template--bundle-sweet-trio .rbr-bundles-container .rbr-mam__productDetail__container', function(){
    $('.template--bundle-sweet-trio .rbr-bundles-container .rbr-mam__productDetail__container').each(function(){
      var lengthSelected11 = ($('.rbr-mam__productDetail__selected').length);
      console.log(lengthSelected11)
      if(lengthSelected11 == 3){
        $(".rbr-mam__productDetail__container:not('.rbr-mam__productDetail__selected') .rbr-checkbox__container input").attr('disabled', 'disabled');
      }else{
        $(".rbr-mam__productDetail__container:not('.rbr-mam__productDetail__selected') .rbr-checkbox__container input").removeAttr('disabled');
      }
    });
  });
  

  // --- ( Trio Product bundle select only 3 End ) ---

  // --- ( Product bundle select only 2 End ) ---

  $(document).on('click', '.template--bundle-pick-2-set .rbr-hr_products .rbr-hrProducts__container', function(){
    $('.template--bundle-pick-2-set .rbr-hr_products .rbr-hrProducts__container').each(function(){
      var lengthSelected = ($('.selected').length);
      console.log(lengthSelected)
      if(lengthSelected == 2){
        $(".rbr-hrProducts__container:not('.selected') .rbr-checkbox__container input").attr('disabled', 'disabled');
      }else{
        $(".rbr-hrProducts__container:not('.selected') .rbr-checkbox__container input").removeAttr('disabled');
      }
    });
  });
  

  });


  
// ---- ( Variants ) ----
   document.addEventListener("DOMContentLoaded", function () {
  const dropdown = document.querySelector(".custom-dropdown");
  const options = document.querySelector(".options");

  dropdown.addEventListener("click", function () {
    options.style.display = options.style.display === "block" ? "none" : "block";
  });

  options.addEventListener("click", function (event) {
    const selectedOption = event.target;
    if (selectedOption.tagName === "LI") {
      const url = selectedOption.getAttribute("data-url");
      window.location.href = url; // Redirect to the selected variant's URL
    }
  });
     document.addEventListener("click", function (event) {
    if (!dropdown.contains(event.target)) {
      options.style.display = "none";
    }
  });
});

// --- ( ingredients Popup ) ---


var modal = document.getElementById("myModal");
var btn = document.getElementById("myBtn");
var span = document.getElementsByClassName("close")[0];
var overlay = document.getElementsByClassName("cstm_overlays")[0];


btn.onclick = function() {
  modal.style.display = "block";
  overlay.style.display = "block";
}

span.onclick = function() {
  modal.style.display = "none";
  overlay.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    overlay.style.display = "none";

  }
}

